import { Component, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'jhi-option',
  template: '<ng-content></ng-content>',
  styleUrls: ['./option.component.scss']
})
export class OptionComponent  {

  @Input()
  value: boolean;

  @Input()
  disabled: boolean;

  constructor(private elRef: ElementRef) {

  }

  get label(): any {
    return this.elRef.nativeElement.innerHTML;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/option/option.component.ts